<script>
import Vue from "vue";

export default Vue.extend({
    data: () => ({
        footerProps: {
            itemsPerPageOptions: [10, 20, 100, 500],
        },
    }),
    computed: {
        scope() {
            return {
                footerProps: this.footerProps,
            }
        },
    },
    render() {
        return this.$scopedSlots.default(this.scope)
    },
})
</script>
